export default "__VITE_ASSET__np$yENlc__"